import { useEffect, useState } from "react";
import SearchableSelect from "../../../../Components/SearchableSelect";
import { useForm } from "react-hook-form";
import { searchCustomersAsync } from "../../../../CRM/store/api/CustomerApi";
import { normalizeIranPhone, validateMobile } from "../../../../store/api/CommonFunctions";
import { Col, Row } from "react-bootstrap";
import './CustomerPanel.css';

export default function CustomerPanel({ invoiceData, setInvoiceData }) {
    const [searchData, setSearchData] = useState({
        InvoiceCustomers: true,
        JustCustomers: true,
        Take: 100
    });
    const [searchResult, setSearchResult] = useState([]);
    const handleCustomerSelect = (opt) => {
        setInvoiceData(prev => ({
            ...prev,
            CustomerID: opt.value,
            CustomerName: opt.name ?? opt.label,
            CustomerMobile: opt.mobile ?? opt.label,
            CustomerPhone: opt.phone ?? ""
        }))
    }
    const handleNameSearch = async (data) => {

        data = String(data).trim();
        if (!data?.length > 0) {
            setInvoiceData(prev => ({ ...prev, CustomerName: data, CustomerID: null }));;
        }
        const sData = { ...searchData, Name: data };
        //setSearchData(prev => ({ ...prev, Name: data }));
        const result = await searchCustomersAsync(sData);
        if (Array.isArray(result?.Data) && result.Data.length > 0) {
            return result.Data.map(r => ({
                value: r.ID,
                label: [r.FirstName, r.Name].filter(r => r?.length > 0).join("-"),
                mobile: r.Mobile,
                phone: r.Phone
            }));
        }
        else {
            setInvoiceData(prev => ({ ...prev, CustomerName: data, CustomerID: null }));

        }
        return [];
    }
    const handleMobileSearch = async (data) => {

        const mobileResult = validateMobile(data);
        if (!mobileResult.valid) {
            setInvoiceData(prev => ({ ...prev, CustomerMobile: data, CustomerID: null }));
            return;
        }
        data = mobileResult.number;

        const sData = { ...searchData, Mobile: data };
        //setSearchData(prev => ({ ...prev, Mobile: data }));
        const result = await searchCustomersAsync(sData);
        if (Array.isArray(result?.Data) && result.Data.length > 0) {
            return result.Data.map(r => ({
                value: r.ID,
                label: r.Mobile,
                name: [r.FirstName, r.Name].filter(r => r?.length > 0).join("-"),
                phone: r.Phone
            }));
        }
        else {
            setInvoiceData(prev => ({ ...prev, CustomerMobile: data, CustomerID: null }));
        }
        return [];
    }
    const handlePhoneSearch = async (data) => {

        const phoneResult = normalizeIranPhone(data);
        if (!phoneResult) {
            setInvoiceData(prev => ({ ...prev, CustomerPhone: data, CustomerID: null }));
            return;
        }
        data = phoneResult;

        const sData = { ...searchData, Phone: data };
        //setSearchData(prev => ({ ...prev, Phone: data }));
        const result = await searchCustomersAsync(sData);
        if (Array.isArray(result?.Data) && result.Data.length > 0) {
            return result.Data.map(r => ({
                value: r.ID,
                label: r.Mobile ?? "",
                name: [r.FirstName, r.Name].filter(r => r?.length > 0).join("-"),
                phone: r.Phone ?? ""
            }));
        }
        else {
            setInvoiceData(prev => ({ ...prev, CustomerPhone: data, CustomerID: null }));
        }
        return [];
    }
    return (
        <Row className="customer-panel-container">
            <Col>
                <SearchableSelect
                    value={invoiceData?.CustomerID ?? 0}
                    defaultLabel={invoiceData?.CustomerName ?? ""}
                    placeholder="جستجوی نام ..."
                    loadOptions={handleNameSearch}
                    onChange={handleCustomerSelect}
                />
            </Col>
            <Col>
                <SearchableSelect
                    value={invoiceData?.CustomerMobile ?? 0}
                    defaultLabel={invoiceData?.CustomerMobile ?? ""}
                    placeholder="جستجوی شماره همراه ..."
                    loadOptions={handleMobileSearch}
                    onChange={handleCustomerSelect}
                />
            </Col>
            <Col>
                <SearchableSelect
                    value={invoiceData?.CustomerPhone ?? 0}
                    defaultLabel={invoiceData?.CustomerPhone ?? ""}
                    placeholder="جستجوی تلفن ..."
                    loadOptions={handlePhoneSearch}
                    onChange={handleCustomerSelect}
                />
            </Col>
        </Row>
    )
}